import forword from "./ForwardW.svg";
import cross from "./cross.svg";
import edit from "./edit.svg";
import back from "./backbuttonGloble.svg";
import editadmin from "./editglobaladmin.svg";
import deletadmin from "./Deleteglobaladmin.svg";
import Imageicon from "./imageglobaladmin.svg";
import uploadLogo from "./uploadLogo.svg";
import deleteIcon from "./Delete.svg";
import dragIcon from "./Drag.svg";
import logoSvg from "./logo.svg";
import logogreenSvg from "./logocontainer.svg";
import sorting from "./sorting.svg";
import plusIcon from "./plusGlobal.svg";
import strockGreen from "./strock.svg";
import OrgListusericon from "./OrganizationUserList.svg";
import profileUser from "./ProfileMyAccount.svg";
import closeRoundedButton from "./close-white.svg";
import DeleteGreenIcon from "./delete-green-icon.svg";
import ProfileLogout from "./ProfileLogout.svg";
import EditGreenIcon from "./edit-green-icon.svg";
import ProjectIcon from "./Projects.svg";
import OrganizationIcon from "./Organization.svg";
import UsersIcon from "./Users.svg";
import CheckGreenIcon from "./right-check-green.svg";
import RedDelete from "./red-delete.svg";
import plusThemeSvg from "./plus-theme.svg";
import approve from "./approve.svg";
import reject from "./reject.svg"

const images = {
  logo: require("./logo.png"),
  project1: require("./project1.png"),
  project2: require("./project2.png"),
  project3: require("./project3.png"),
  project4: require("./project4.png"),
  rightarrow: require("./right-arrow.png"),
  alert: require("./alert.png"),
  backarrow: require("./backarrow.png"),
  bookinglist: require("./bookinglist.png"),
  calender: require("./calender.png"),
  companySetting: require("./cmpny-setting.png"),
  collapse: require("./collapse.png"),
  completedStep: require("./completed-step.png"),
  done: require("./done.png"),
  download: require("./download.png"),
  form2: require("./form2.png"),
  ForwardArrow: require("./ForwardArrow.png"),
  location: require("./location.png"),
  logoMini: require("./logo-mini.png"),
  logonew: require("./logonew.png"),
  minus: require("./minus.png"),
  notification: require("./notification.png"),
  plusTheme: require("./plus-theme.png"),
  plus: require("./Plus.png"),
  search: require("./Search.png"),
  siteManagement: require("./site-management.png"),
  users: require("./users.png"),
  logoimage: require("./banner-logo.png"),
  banner: require("./Banner.png"),
  locationicon: require("./location.png"),
  clockicon: require("./clock.png"),
  calendericon: require("./calender.png"),
  organization: require("./Vector(Stroke).png"),
  RedDelete,
  plusThemeSvg,
  usersAdmin: require("./usersAdmin.png"),
  edit,
  forword,
  cross,
  back,
  editadmin,
  deletadmin,
  Imageicon,
  uploadLogo,
  deleteIcon,
  dragIcon,
  sorting,
  logoSvg,
  logogreenSvg,
  plusIcon,
  strockGreen,
  OrgListusericon,
  profileUser,
  closeRoundedButton,
  DeleteGreenIcon,
  ProfileLogout,
  EditGreenIcon,
  ProjectIcon,
  OrganizationIcon,
  UsersIcon,
  CheckGreenIcon,
  approve,
  reject,
};
export default images;
